var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuestic-widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"vuestic-widget-header"},[_vm._v(_vm._s(_vm.headerText))]):_vm._e(),(_vm.hasSlotData)?_c('div',{staticClass:"vuestic-widget-body"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }